<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :batch-edit="auth('b_process_edit')" :view-config="auth('b_process_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="工艺编号">
							<c-input name="process_code"></c-input>
						</m-search-item>
						<m-search-item label="工艺名称">
							<c-input name="process_name"></c-input>
						</m-search-item>
						<m-search-item label="加工类型">
							<c-select name="process_type" :options="processTypeDic"></c-select>
						</m-search-item>
						<m-search-item label="检验方式">
							<c-select name="test_mode" :options="testModeDic"></c-select>
						</m-search-item>
						<m-search-item label="自动出库">
							<c-select name="material_auto_out" :options="openCloseDic"></c-select>
						</m-search-item>
						<m-search-item label="自动入库">
							<c-select name="product_auto_in" :options="openCloseDic"></c-select>
						</m-search-item>
						<m-search-item label="报工前打卡">
							<c-select name="output_start" :options="openCloseDic"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_process_edit')" v-lock="lock('b_process_edit')" prepend-icon="tf-add" @click="editDicProcess()">创建工序</c-button>
					<c-button v-if="auth('b_process_export')" v-lock="lock('b_process_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_process_export')" v-lock="lock('b_process_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_process_edit')" v-lock="lock('b_process_edit')" prepend-icon="tf-import" @click="$refs.view.excelImport()">导入</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_process_export')" v-lock="lock('b_process_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_process_export')" v-lock="lock('b_process_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_process_print')" v-lock="lock('b_process_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
					<c-button v-if="auth('b_process_edit')" v-lock="lock('b_process_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveDicProcess">删除</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_process_log')" v-lock="lock('b_process_log')" prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_process_log')" v-lock="lock('b_process_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>
				
				<!--报工权限-->
				<template #output_auth_names="{data}">
					<span v-if="!data.output_auth_names" >-</span>
					<c-tags v-else :value="data.output_auth_names"></c-tags>
				</template>
				<!--良品项列表-->
				<template #defects_names="{data}">
					<span v-if="!data.defects_names">-</span>
					<c-tags v-else :value="data.defects_names"></c-tags>
				</template>
                <!--工序图-->
                <template #process_image="{data}">
                    <c-file v-if="data.process_image" class="image" :src="data.process_image" media style="width:25px;height:25px;"></c-file>
                </template>
				<!--工序物料自动出库（0：不开启，1：开启）-->
				<template #material_auto_out="{data}">
					<c-state dict="openCloseDic" :value="data.material_auto_out"></c-state>
				</template>
				<!--成品自动入库（0：不开启，1：开启）-->
				<template #product_auto_in="{data}">
					<c-state dict="openCloseDic" :value="data.product_auto_in"></c-state>
				</template>
				<!--加工类型（1：自制，2：外协）-->
				<template #process_type="{data}">
					<c-state dict="processTypeDic" :value="data.process_type"></c-state>
				</template>
				<!--检验方式（1：免检，2：首检，3：全检）-->
				<template #test_mode="{data}">
					<c-state dict="testModeDic" :value="data.test_mode"></c-state>
				</template>
				<!--报工前打卡（0：不开启，1：开启）-->
				<template #output_start="{data}">
					<c-state dict="openCloseDic" :value="data.output_start"></c-state>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="4"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_process_edit')" v-lock="lock('b_process_edit')" icon="tf-edit" @click="editDicProcess(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_process_print')" v-lock="lock('b_process_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_process_edit')" v-lock="lock('b_process_edit')" icon="tf-trash" color="red" @click="removeDicProcess(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
				workType:9
			}
		},

		computed: {
			...mapState(['openCloseDic','processTypeDic','testModeDic'])
		},
		
		methods: {
			/******新建/编辑工序*******/
			editDicProcess(data) {
				this.globalDialog('processEdit', {data}, this.$refs.view.update);
			},
			
			/****批量删除工序***/
			batchRemoveDicProcess(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条工序记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/dic/process/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******删除工序************/
			removeDicProcess(data){
				this.$confirm({
					message:'确认删除工序【'+data.process_name+'】？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/dic/process/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>